// frontend/src/utils/getProductsOptions.js
const getProductsOptions = (products = [], kColorProducts = [], showArtCod = false) => {
  const standardOptions = products.map(p =>
    showArtCod
      ? {
          value: p.id,
          label: p.art_cod,
          secondaryLabel: p.art_des_cmpy,
        }
      : {
          value: p.id,
          label: p.art_des_cmpy,
        }
  );

  const kColorOptions = kColorProducts.map(k =>
    showArtCod
      ? {
          value: k.cod_prod_comm,
          label:`id. K-COLOR: ${k.cod_prod_comm}`,
          secondaryLabel: k.des_prod_comm,
        }
      : {
          value: k.cod_prod_comm,
          label: k.des_prod_comm,
        }
  );

  return [...standardOptions, ...kColorOptions].sort((a, b) => {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  });
};

export default getProductsOptions;